import { render, staticRenderFns } from "./SellingPoint.vue?vue&type=template&id=3dbe758a&scoped=true&"
import script from "./SellingPoint.vue?vue&type=script&lang=ts&"
export * from "./SellingPoint.vue?vue&type=script&lang=ts&"
import style0 from "./SellingPoint.vue?vue&type=style&index=0&id=3dbe758a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbe758a",
  null
  
)

export default component.exports